import {useParams, useRouteMatch} from 'react-router-dom';
import {AssociateExternalAccountForm} from '../../../../../../../components/associate-external-account-form/associate-external-account-form';

export default function SeniorAssociateExternalAccountSystemAdministratorOfficeScreen() {
  // Get params
  let {id}: {id?: string} = useParams();

  // The `path` lets us build <Route> paths that are
  // relative to the parent route, while the `url` lets
  // us build relative links.
  let {url} = useRouteMatch();

  return (
    <AssociateExternalAccountForm
      userId={id || ''}
      redirectUrl={`${url.replace('/associate', '')}`}
    />
  );
}
